/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleFilter {
    getFixupPrototypeFunction() { return ScheduleFilter.fixupPrototype; }

    static newInstance(model: Partial<ScheduleFilter>): ScheduleFilter {
        let obj = Object.assign(new ScheduleFilter(), model);
        ScheduleFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleFilter>): ScheduleFilter {
        if (!model) return null;
        return ScheduleFilter.newInstance(<ScheduleFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleFilter) {
        if (!obj) return;

        models.ScheduleFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleFilter): boolean {
        Object.setPrototypeOf(obj, ScheduleFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Category of the schedule
     */
    category: models.ScheduleCategory;

    /**
     * Flag to represent whether the schedule is active or not.
     */
    is_active: boolean;

    query: models.QueryOperator;

}
